import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('we_received_a_request_t_ange_your_email_address'),
    description: defineMessage('once_this_has_been_proc_k_you_for_your_patience'),
    buttonDone: defineMessage('done'),
};
